import React from 'react';

import { formatCurrency } from '@C/TableGrid';
import './styles.scoped.scss';

const CashDenominationDetails = ({
  cashDenominationList = {},
  cashManagementAmount = 0,
  cashManagementName = '',
  onRequestClose,
}) => {
  const denominationRows = Array.isArray(cashDenominationList.cash_denomination)
    ? cashDenominationList.cash_denomination
    : [];
  const filteredDenominationRows = denominationRows.filter(
    (item) => item.count > 0,
  );
  const totalAmount = filteredDenominationRows.reduce(
    (sum, item) => sum + Number(item.amount || 0),
    0,
  );
  const summaryAmount = Number(
    cashDenominationList.cash_management_amount || cashManagementAmount || 0,
  );
  const summaryLabel =
    cashDenominationList.cash_management_name ||
    cashManagementName ||
    'Cash in hand';

  return (
    <section className="widget full-width form-table form-wrap">
      <header>
        <h3> Denomination </h3>
      </header>
      <main>
        <div className="form-content">
          {filteredDenominationRows && filteredDenominationRows.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th> Denomination</th>
                  <th> Count </th>
                  <th> Amount </th>
                </tr>
              </thead>
              <tbody>
                {filteredDenominationRows.map((item, i) => {
                  return (
                    <tr key={i}>
                      <td>
                        <div className="input-wrapper denomination-cell">
                          {item.denomination_icon && (
                            <img
                              className="img-input compact"
                              src={item.denomination_icon}
                              alt={`${item.denomination_details__value} note`}
                            />
                          )}
                          <span className="denomination-label">
                            {formatCurrency(
                              item.denomination_details__value || 0,
                              0,
                            )}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div className="input-wrapper --wrap">
                          <span>{item.count || 0}</span>
                        </div>
                      </td>
                      <td>
                        <div className="input-wrapper --wrap">
                          <div className="denomination-amount">
                            {formatCurrency(item.amount || 0)}
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className="notification-alert notification-alert__error">
              No denominations added for this entry
            </div>
          )}
        </div>
      </main>
      <div className="table-wrapper">
        <div className="denomination-summary">
          <div className="summary-card">
            <span className="summary-label">{summaryLabel}</span>
            <strong className="summary-value">
              {formatCurrency(summaryAmount || 0)}
            </strong>
          </div>
          <div className="summary-card highlight-total">
            <span className="summary-label">Denomination total</span>
            <strong className="summary-value">
              {formatCurrency(totalAmount || 0)}
            </strong>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CashDenominationDetails;
